import { useEffect, useState } from "react";
import clienteAxios from "../../../configAxios/configAxios";


const useModelo = (slug) => {
    const [ficha, setFicha] = useState(undefined);
    const [error,setError] = useState(false);
    const [loading,setLoading] = useState(true);

    useEffect(() => {
        if(slug){
            const fetchFichaVehiculo = async () => {
                try {
                    let response = await clienteAxios.get(`Modelo/fichaVehiculo/${slug}`);
                    setLoading(false);
					if(response.status === 200){
                        let data = response.data.data;
                        if(data.Slider && data.Slider.length > 0 && data.Vehiculo){
                            data.Slider.map((multi) => multi.Tipo === "IMG" ? multi.Modelo = data.Vehiculo.Modelo : null)
                        }
                        setFicha(data)
                        return;
                    }
                    setError(true);
                    
                } catch (error) {
                    setError(true);
                    setLoading(false);
                }
            };
            fetchFichaVehiculo();
        }
        
    },[slug])

    return [ficha,loading,error];
};

export default useModelo;